<template>
  <div>
    <h2>Find all relatives of</h2>
    <img v-if="targetUser" :src="targetUser.croppedImage" />

    <div class="images">
      <div v-for="combination in combinations" :key="combination.id">
        <MorphedImage
          :img1="combination.person1.croppedImage"
          :img2="combination.person2.croppedImage"
          :landmarks1="combination.person1.landmarks"
          :landmarks2="combination.person2.landmarks"
          :class="imageClasses(combination)"
          @click="selectImage(combination.id)"
        />
      </div>
    </div>

    <router-link :to="{ name: 'PlayerLobby' }"
      ><button>Finish</button></router-link
    >
    <button v-if="gameState == 'start'" @click="verifyGuess()">
      Continue
    </button>
    <button v-else @click="nextRound()">Next Round</button>
  </div>
</template>

<script>
// import MessageBox from "@/components/MessageBox.vue";
import faceLibrary from "@/faceLibrary";
import store from "@/store";
import MorphedImage from "@/components/MorphedImage.vue";

function shuffle(array) {
  var currentIndex = array.length,
    temporaryValue,
    randomIndex;

  // While there remain elements to shuffle...
  while (0 !== currentIndex) {
    // Pick a remaining element...
    randomIndex = Math.floor(Math.random() * currentIndex);
    currentIndex -= 1;

    // And swap it with the current element.
    temporaryValue = array[currentIndex];
    array[currentIndex] = array[randomIndex];
    array[randomIndex] = temporaryValue;
  }

  return array;
}

function createCombinations(sources) {
  let result = [];
  for (let start = 0; start < sources.length - 1; ++start) {
    for (let i = start + 1; i < sources.length; ++i) {
      const person1 = sources[start];
      const person2 = sources[i];
      const combination = {
        id: `${person1.id}:${person2.id}`,
        person1,
        person2,
      };
      result.push(combination);
    }
  }
  return result;
}

const winText = `Amazing you are really one of a kind. Finally all the self love and
      narcissism pays of.You have studied yourself thoroughly and no one could
      ever fool you into believing they belong to your family when they are not.`;
const looseText = `You Fool`;

export default {
  components: {
    // MessageBox,
    MorphedImage,
  },
  data() {
    return {
      targetUser: null,
      combinations: [],
      result: null,
      overlay: false,
      solution: null,
      winText,
      looseText,
      selectedImages: [],
    };
  },
  beforeRouteEnter(to, from, next) {
    if (!store.state.players.length) {
      next({ name: "PlayerLobby" });
    }
    next();
  },
  watch: {
    targetUser: {
      immediate: true,
      handler(newValue) {
        if (!newValue) {
          this.reset();
        }
      },
    },
  },
  created() {
    this.setState("start");
    this.setSolution();
  },
  computed: {
    solutionActive() {
      return this.$store.state.gameState == "end";
    },
    morphs() {
      return this.$store.state.morphs;
    },
    sources() {
      return this.$store.state.players;
    },
    gameState() {
      return this.$store.state.gameState;
    },
  },
  methods: {
    reset() {
      this.targetUser = this.sources[
        Math.floor(Math.random() * this.sources.length)
      ];

      const externalImages = shuffle(faceLibrary);
      let sources = [...this.sources, ...externalImages].slice(0, 10);
      let combinations = createCombinations(sources);
      const randomCombinations = shuffle(combinations).slice(0, 10);
      this.selectedImages = [];
      this.combinations = randomCombinations;
      this.setState("start");
    },
    selectImage(image) {
      if (this.gameState == "end") return;
      const alreadSelected = this.selectedImages.find((e) => e == image);
      if (alreadSelected) {
        this.selectedImages = this.selectedImages.filter((i) => i != image);
      } else {
        this.selectedImages.push(image);
      }
    },
    imageClasses(combination) {
      let selected = this.selectedImages.find((i) => i == combination.id);
      let correct = false;
      let wrong = false;
      if (this.gameState == "end") {
        if (
          combination.person1.id == this.targetUser.id ||
          combination.person2.id == this.targetUser.id
        ) {
          correct = true;
        } else if (selected) {
          wrong = true;
        }
      }
      return {
        selected,
        correct,
        wrong,
      };
    },
    setState(state) {
      this.$store.commit("SET_STATE", state);
    },
    setSolution() {
      this.solution = this.morphs.you;
    },
    newGame() {
      this.setState("end");
      this.$router.push({ name: "PlayerLobby" });
    },
    showSolution() {
      this.setState("end");
    },
    verifyGuess() {
      this.setState("end");
    },
    nextRound() {
      this.reset();
    },
    handleChoice(option) {
      if (option == "New Game") {
        this.newGame();
      } else if (option == "Show Solution") {
        this.showSolution();
      } else if (option == "Try Again") {
        this.overlay = false;
      }
    },
  },
};
</script>

<style lang="scss" scoped>
.image {
  margin: 10px;
  max-width: 200px;
  border-radius: 6px;
}
.images {
  display: flex;
  justify-content: center;
  flex-wrap: wrap;
}

.border {
  border: 10px solid transparent;
}

.selected {
  border-color: blue;
}

.correct {
  border-color: green;
}

.wrong {
  border-color: red;
}
</style>
